import React from 'react';
import { Label } from '../../';
import * as S from './SelectInput.style';
export const SelectInput = ({ value, onChange, placeholder, disabled, label = '', children, ...rest }) => (React.createElement(S.SelectInputWrapper, null,
    React.createElement(S.Label, null,
        React.createElement(Label, { htmlFor: label, value: label }),
        React.createElement(S.SelectInput, Object.assign({ name: label, value: value, onChange: onChange }, rest), children))));
//# sourceMappingURL=SelectInput.js.map